import { Button, Container, Grid, Typography } from "@mui/material";
import { ArrowForward as ArrowForwardIosIcon } from "@mui/icons-material";
import Header from "../../Header";
import Slider from "react-slick";
import SliderImg from "../../../../assets/image/ezgif.com-resize-1.png";
import SliderImg2 from "../../../../assets/image/ezgif.com-resize-2.png";
import SliderImg3 from "../../../../assets/image/ezgif.com-gif-maker-5.png";
import SliderImg4 from "../../../../assets/image/ezgif.com-gif-maker-1-1.png";
import SliderImg5 from "../../../../assets/image/jjjjlogo.png";
import SliderImg6 from "../../../../assets/image/ezgif.com-gif-maker-10.png";
import SliderImg7 from "../../../../assets/image/ezgif.com-gif-maker-6.png";
import LaptopImg from "../../../../assets/image/web-devloper.png";
import OurTeamImg from "../../../../assets/image/img_box_24.png";
import OurTeamImg2 from "../../../../assets/image/img_box_25.png";
import OurTeamImg3 from "../../../../assets/image/img_box_26.png";
import OurTeamImg4 from "../../../../assets/image/img_box_27.png";
import OurTeamBgImg from "../../../../assets/image/SMM_bg__img-scaled.png";
import WhyChooseImg from "../../../../assets/image/analytics.gif";
import KeyBnifitsImg from "../../../../assets/image/file (2).png";
import FooterSvg from "../../../../assets/image/Untitled-3.svg";
import "./WebDesign.css";
import Footer from "../../Footer";

const WebDesign = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 9,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const ourTeamGridData = [
    {
      id: 1,
      imgSrc: OurTeamImg,
      color: "#695ce8",
      title: "Website Design and Development",
      description:
        "We provide robust PHP web development services to our global clients in UK, USA, and India. Our programmers are well-known for providing custom PHP solutions which are customized to match your unique business requirements.",
    },
    {
      id: 2,
      imgSrc: OurTeamImg2,
      color: "#f47514",
      title: "Web Portal Development",
      description: `Our PHP website programmers are experts in providing CRM solutions and developing custom features from scratch. Our PHP Development agency ensures that our CRM functionality works perfectly as needed by you.`,
    },
    {
      id: 3,
      imgSrc: OurTeamImg3,
      color: "#ff4a69",
      title: "Custom Development",
      description: `Our PHP experts offer cloud services like SaaS, LaaS, PaaS and many more backend solution. We provide full stack PHP web development services from initial consultation, to the final PHP application.`,
    },
    {
      id: 4,
      imgSrc: OurTeamImg4,
      color: "#38c77b",
      title: "Ecommerce Development",
      description: `We provide ecommerce PHP solutions on wordpress, laravel, magento and woocommerce. Our PHP Development company in guwahati  provides full customization services and can help you to add new features to your site .`,
    },
    {
      id: 5,
      imgSrc: OurTeamImg4,
      color: "#38c77b",
      title: "Support & Maintenance",
      description: `We provide PHP support and maintenance after project completion with 24/7 chat suppport . Our PHP team have worked with small business , large scale enterprise , or any complex business process.`,
    },
    {
      id: 6,
      imgSrc: OurTeamImg3,
      color: "#ff4a69",
      title: "ERP Solutions",
      description: `As a leading PHP application development company, we offer services like custom ERP development on wordpress, Drupal and WordPress. We create custom ERP which are secure, and fast.`,
    },
  ];

  const frontEndDemoData = [
    { id: 1, title: "Javascript", categoryId: 1 },
    { id: 2, title: "Type Script", categoryId: 1 },
    { id: 3, title: "Angular", categoryId: 1 },
    { id: 4, title: "React JS", categoryId: 1 },
    { id: 5, title: "Vue JS", categoryId: 1 },
    { id: 6, title: "Backbone js", categoryId: 1 },
    { id: 7, title: "Emberjs", categoryId: 1 },
    { id: 8, title: "Bootstrap", categoryId: 1 },
    { id: 9, title: "HTML5", categoryId: 1 },
    { id: 10, title: "CSS3", categoryId: 1 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Laravel", categoryId: 2 },
    { id: 11, title: "Firebase", categoryId: 3 },
    { id: 11, title: "Firebase", categoryId: 3 },
    { id: 11, title: "Firebase", categoryId: 3 },
    { id: 11, title: "Firebase", categoryId: 3 },
    { id: 11, title: "Firebase", categoryId: 3 },
    { id: 11, title: "Firebase", categoryId: 3 },
    { id: 11, title: "Firebase", categoryId: 3 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
    { id: 11, title: "Adobe XD", categoryId: 4 },
  ];

  const titleData = [
    {
      id: 1,
      title: "Front End",
    },
    {
      id: 2,
      title: "Back End",
    },
    {
      id: 3,
      title: "Database",
    },
    {
      id: 4,
      title: "Design Tools",
    },
  ];

  const whyChooseUsData1 = [
    { id: 1, desc: "Static website Design starting at Rs. 2999" },
    { id: 2, desc: "Custom Website Designing" },
    { id: 3, desc: "Education Institute Website Design" },
    { id: 4, desc: "School Website Design" },
  ];

  return (
    <>
      <Header />
      <section>
        <Container>
          <Grid container spacing={0}>
            <Grid item xs={12} md={6}>
              <div style={{ textTransform: "uppercase", fontWeight: "bold" }}>
                Web Development services
              </div>
              <br />
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  textTransform: "uppercase",
                  fontWeight: "bold",
                  color: "#3a506b",
                }}
              >
                Web Design & <br />
                Development Services
              </Typography>
              <br />
              <br />
              <Button
                style={{
                  padding: "15px 25px 15px 25px",
                  background: "#6254e7",
                  color: "white",
                  marginBottom: "20px",
                }}
                variant="contained"
                color="#7209b7"
              >
                Explore More
              </Button>
            </Grid>
            <Grid item xs={12} md={6}>
              <div
                style={{
                  textTransform: "uppercase",
                  fontWeight: "bold",
                  color: "#6254e7",
                }}
              >
                Web Development services
              </div>
              <p style={{ fontSize: "22px" }}>
                Top Web Development Services in Guwahati Specialized to Create
                Robust Website and Applications.
              </p>
              <p style={{ fontSize: "22px" }}>
                As a leading&nbsp;
                <strong style={{ fontWeight: "bold" }}>
                  Web Development Services in Guwahati
                </strong>
                , we always create robust, secure, custom web application with
                high scalability. According to the need of product, we use open
                source technology to develop a product with high quality
                standard. We help you stand out in this digital world by
                providing bespoke web development solutions.
              </p>
            </Grid>
          </Grid>
        </Container>
      </section>

      <section>
        <Container>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              textTransform: "uppercase",
              fontSize: "17px",
            }}
          >
            <h3 style={{ fontWeight: "bold" }}>Our Happy Clients</h3>
          </div>
          <div className="slider-container">
            <Slider {...settings}>
              <div>
                <img width={70} src={SliderImg} alt="Client 1" />
              </div>
              <div>
                <img width={70} src={SliderImg2} alt="Client 2" />
              </div>
              <div>
                <img width={70} src={SliderImg3} alt="Client 3" />
              </div>
              <div>
                <img width={70} src={SliderImg4} alt="Client 4" />
              </div>
              <div>
                <img width={70} src={SliderImg5} alt="Client 5" />
              </div>
              <div>
                <img width={70} src={SliderImg6} alt="Client 6" />
              </div>
              <div>
                <img width={70} src={SliderImg7} alt="Client 6" />
              </div>
            </Slider>
          </div>
        </Container>
      </section>

      {/* video section  */}

      <section>
        <Container>
          <Grid container spacing={0}>
            <Grid item xs={12} md={5}>
              <div style={{ textTransform: "uppercase", fontWeight: "bold" }}>
                Trusted Web Development services
              </div>
              <Typography
                variant="h6"
                gutterBottom
                sx={{ fontWeight: "bold", color: "#3a506b" }}
              >
                Cutting-edge Web Development Services You Need for Your Business
                Growth.
              </Typography>
              <p style={{ fontSize: "20px" }}>
                Ozosoft offers high-quality web app development services by
                keeping targeted customers in mind for startups, mid-sized
                companies, and enterprises. As a reputed&nbsp;
                <strong style={{ fontWeight: "bold" }}>
                  Web Development Services in Guwahati
                </strong>
                , we have a dedicated team of web developers who can work with
                latest technology and you can hire web developer for your
                project need.
              </p>
            </Grid>
            <Grid item xs={12} md={7}>
              <img src={LaptopImg} />
            </Grid>
          </Grid>
          <Grid container spacing={0}>
            <Grid item xs={12} md={6}></Grid>
            <Grid item xs={12} md={6}>
              <p style={{ textTransform: "uppercase", textAlign: "center" }}>
                Web development services
              </p>
            </Grid>
            <p style={{ fontSize: "20px" }}>
              Reseller Bano, one of the{" "}
              <a href="#">
                Top Web Design Company in Guwahati, Assam
              </a>
              , India Our customers are companies of all sizes ranging from
              start-ups to large enterprises who realize that they need a
              professional internet solution to set up revenue streams, build
              communication channels or streamline business operations. Our core
              competency is to promote your business online, to create online
              business opportunities and leads, and to empower your business. We
              are one of the best and Supportive website Design and Developers
              in the Guwahati, Assam, If you are looking for most affordable,
              creative, Reliable Professional website.
            </p>
          </Grid>
        </Container>
      </section>

      <section
        style={{
          backgroundImage: `url(${OurTeamBgImg})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          padding: "20px",
        }}
      >
        <Container>
          <div style={{ textAlign: "center" }}>
            <div style={{ textTransform: "uppercase", fontWeight: "bold" }}>
              Best for you
            </div>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: "bold", color: "#3a506b" }}
            >
              How Our Team Can Help
            </Typography>
            <p style={{ fontSize: "20px" }}>
              We are renowned custom web app development company in <br />{" "}
              Guwahati, offering wide range of web development services <br />{" "}
              that caters to all your business needs:
            </p>
          </div>
          <Grid container spacing={12}>
            {ourTeamGridData.map((item, index) => (
              <Grid item xs={12} md={6} key={item.id}>
                <div style={{ display: "flex", padding: "0px" }}>
                  <img
                    src={item.imgSrc}
                    width={50}
                    height={50}
                    alt="Placeholder 1"
                    style={{ marginRight: "10px" }}
                  />
                  <div>
                    <div
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                        color: `${item.color}`,
                      }}
                    >
                      {"0" + item.id}
                      <br />
                      {item.title}
                    </div>
                    <p
                      className="our-team-card-description"
                      style={{
                        fontSize: "18px",
                        color: "#8d99ae",
                        marginTop: "0",
                      }}
                    >
                      {item.description}
                    </p>
                  </div>
                </div>
              </Grid>
            ))}
          </Grid>
        </Container>
      </section>

      <section
        style={{
          backgroundImage: `url(${OurTeamBgImg})`,
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          padding: "20px",
        }}
      >
        <Container>
          <div style={{ textAlign: "center" }}>
            <div style={{ textTransform: "uppercase", fontWeight: "bold" }}>
              Best for you
            </div>
            <Typography
              variant="h5"
              gutterBottom
              sx={{ fontWeight: "bold", color: "#3a506b" }}
            >
              As a Best Web Development Company in Guwahati, We Use the Best
              Technologies
            </Typography>
            <Grid container spacing={6}>
              {titleData.map((data) => (
                <Grid item xs={6} md={3} key={data.id}>
                  <p style={{ fontWeight: "bold", textAlign: "left" }}>
                    {data.title}
                  </p>
                  <ul style={{ listStyle: "none", padding: 0 }}>
                    {frontEndDemoData
                      .filter((item) => item.categoryId === data.id)
                      .map((item) => (
                        <li
                          key={item.id}
                          className="list-custom-style"
                        >
                          <ArrowForwardIosIcon className="arrow-forward-icon" />
                          {item.title}
                        </li>
                      ))}
                  </ul>
                </Grid>
              ))}
            </Grid>
          </div>
        </Container>
      </section>

      <section>
        <Container>
          <Grid container spacing={0}>
            <Grid
              item
              xs={12}
              md={6}
              sx={{ justifyContent: "center", display: "flex" }}
            >
              <img
                src={WhyChooseImg}
                alt="Why choose Reseller Bano?"
                style={{ width: "350px" }}
              />
            </Grid>
            <Grid item xs={12} md={5}>
              <p className="text-uppercase">Featuers</p>
              <Typography
                variant="h5"
                gutterBottom
                sx={{ fontWeight: "bold", color: "#3a506b" }}
              >
                Why Choose Reseller Bano for Web Development
              </Typography>
              <p style={{ fontSize: "20px" }}>
              Being a well-known web app development company, OZOSOFT is recognized for serving modern business needs and delivering the best-in-class solutions at a competitive cost across the globe. Here’s why we can be the best choice when it comes to building websites and apps:
              </p>
            </Grid>
           
          </Grid>
        </Container>
      </section>

      <section>
        <Container>
          <h5 className="text-uppercase" style={{ fontWeight: "bold" }}>
            Reseller Bano Offers Exceptional Quality Website Design
          </h5>
          <Typography
            variant="h5"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#3a506b" }}
          >
            We Specialize in
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <ul>
                {whyChooseUsData1.map((item, index) => (
                  <li className="list-custom-style">
                    <ArrowForwardIosIcon className="arrow-forward-icon" />
                    {item.desc}
                  </li>
                ))}
              </ul>
            </Grid>
            <Grid item xs={12} md={6}>
              <ul>
                {whyChooseUsData1.map((item, index) => (
                  <li className="list-custom-style">
                    <ArrowForwardIosIcon className="arrow-forward-icon" />
                    {item.desc}
                  </li>
                ))}
              </ul>
            </Grid>
          </Grid>
        </Container>
      </section>

      <section>
        <Container>
          <div
            style={{
              textAlign: "center",
              backgroundImage:
                "linear-gradient(90deg, #56ab2f 0%, #a8e063 100%)",
              padding: "20px",
              color: "#fff",
              borderRadius: "20px",
              boxShadow: "0px 0px 19px 0px rgba(0,0,0,.5)",
            }}
          >
            <p className="text-uppercase text-bold">Welcome</p>
            <Typography
              variant="h4"
              gutterBottom
              sx={{ fontWeight: "bold", color: "#fff" }}
              className="let-discuss-header"
            >
              Let's Discuss Your Project
            </Typography>
            <p className="let-discuss-para" style={{ fontSize: "18px" }}>
              We accept Mobile Application Development projects including Mobile
              App UI/UX Design from all major towns and cities of Assam
              including Guwahati, Silchar, Dibrugarh, Tezpur, Tinsukia,
              Bongaigaon, Mangaldai, Nalbari, Pathsala, Nagaon, Jorhat,
              Sivasagar, Lakhimpur, Dhekiajuli. We haved expanded our services
              to multiple cities of Northeast including Itanagar, Arunachal
              Pradesh, Imphal, Manipur, Shillong, Meghalaya, Aizawl, Mizoram,
              Agartala, Tripura, Kohima, Nagaland
            </p>
            <Button
              style={{
                padding: "15px 25px 15px 25px",
                background: "#fff",
                color: "black",
                borderRadius: "40px",
              }}
              variant="contained"
              color="#7209b7"
              className="text-uppercase"
            >
              Talk our experts
            </Button>
          </div>
        </Container>
      </section>

      <section>
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <p className="text-uppercase text-bold">Analysis</p>
              <Typography
                variant="h6"
                gutterBottom
                sx={{ fontWeight: "bold", color: "#3a506b" }}
                className="let-discuss-header"
              >
                Key Benefits of Having a Website for your Business
              </Typography>
              <p className="ts-18">
                As people spend more than 8 hours a day searching on the
                Internet, every business should have a web presence. Having a
                website for any type of business offers plenty of benefits. Here
                are some crucial reasons to develop a website for your business:
              </p>
              <ul style={{textAlign:'center' , padding:'20px'}}>
                <li className="list-custom-style"> 
                  <ArrowForwardIosIcon className="arrow-forward-icon" />Builds Creditability
                </li>
                <li className="list-custom-style">
                  <ArrowForwardIosIcon className="arrow-forward-icon" />Wider Audience Reach
                </li>
                <li className="list-custom-style">
                  <ArrowForwardIosIcon className="arrow-forward-icon" />Promote Your Business
                </li>
                <li className="list-custom-style">
                  <ArrowForwardIosIcon className="arrow-forward-icon" />Keep Track of Your Business
                </li>
                <li className="list-custom-style">
                  <ArrowForwardIosIcon className="arrow-forward-icon" />Improve Customer Service
                </li>
              </ul>
            </Grid>
            <Grid item xs={12} md={6}>
              <img src={KeyBnifitsImg} alt="Reseller Bano Key Benefits"/>
            </Grid>
          </Grid>

          <p className="text-uppercase text-bold" >We are one of the well-known Web Development Services</p>
          <p className="ts-18">
          Html, Php Web Development Services in Assam with a team of skilled HTML Developers concentrated on latest HTML5, Google API, CSS Manifest, Content Scripting, and many other. Now a days, your website is the foundation of your presence in the Internet, it should be look and feel professional for strong presence over your competitors. With HTML5 responsive design it enables us to make your website compatible to iPhone, android or any other devices including tablets and desktops. Our team adds superior effects for streaming video and audio, Geo location, animated website banners, Offline cache and more tags you can think of o build an innovative, user friendly, more engaging and best performing. Reseller Bano web designing team expertise in building websites using the latest version HML5 with full cross browser support.
         
          With a professional team of developers we at Reseller Bano try to provide the best web development experience to our customers. We offer various solutions to website development. If you are looking for an affordable and effective website, open source platforms can be used. The availability of variety of libraries and wonderful plugins enables effective wiring of codes. MVC frameworks like Codeigniter, Laravel or custom frameworks are useful for clients who already understand their business well and want to transfer it online. It is especially remarkable given the ease of testing with each new addition of Features. We Reseller Bano, a
          </p>
          <img src={FooterSvg} />
        </Container>
      </section>

      <Footer/>
    </>
  );
};

export default WebDesign;
